import { GridColumn, GridColumnType, GridColumnWithoutSort } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import RepresentanteModel from "@/models/representanteModel";
import representanteService from "@/services/representanteService";

import ListComponentBase from "../listComponentBase";

@Component
export default class RepresentanteListComponent extends ListComponentBase<RepresentanteModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nome", this.$t("__.ts.nome"), GridColumnType.String, false, false, "", "", true),
            new GridColumnWithoutSort("cpfFormatado", "CPF", GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(representanteService, "representante", "nome");
    }
}
